import $ from 'jquery';
import Swiper from 'swiper';
import Component from '../model/Component';

class GazzetteRelatedSliderComponent extends Component {
    constructor(element, parentCtrl) {
        super(element, parentCtrl);

        this.$element = $(element);
        this.spv = 0;

        $(window).resize(() => {
            this.onResize();
        })
        this.onResize();
    }

    onResize() {
        let newSpv = null;
        if ($(window).width() > 767) {
            newSpv = 2;
        } else {
            newSpv = 1;
        }

        if (newSpv != this.spv) {
            this.spv = newSpv;
            this.destroySwiper();
            this.initSwiper();
        }
    }

    initSwiper() {
        this.swiper = new Swiper(this.$element[0], {
            slidesPerView: this.spv,
            spaceBetween: 15,
            nextButton: '.gazzette-news-related .swiper-button-next',
            prevButton: '.gazzette-news-related .swiper-button-prev',
            pagination: '.swiper-pagination',
            paginationClickable: true,
            loop: true,
            speed: 1000
        })
    }

    destroySwiper() {
        if (!!this.swiper) {
            this.swiper.destroy(true, true);
            delete this.swiper;
        }
    }
}

export default GazzetteRelatedSliderComponent;
